import React from 'react'

const Header = ({ invoiceDate, invoiceDueDate, customerId, invoiceId }) => {
  return (
    <div className="flex flex-row justify-between mt-6">
      <div className="flex flex-row w-1/2">
        <img
          src="https://lightrains.com/assets/img/lightrains-logo.png"
          className="h-32 w-32"
          alt="logo"
        />
        <div className="ml-3">
          <h2 className="text-lg font-bold">Lightrains Technolabs</h2>
          <p>Module 2, Gayathri</p>
          <p>Technopark Campus</p>
          <p>Trivandrum Kerala - 695581</p>
          <p>India</p>
        </div>
      </div>
      <div className="w-1/2 pl-20 ">
        <div className="flex flex-row">
          <h2 className="w-2/4 text-lg font-bold uppercase mb-4">Invoice</h2>
          <p className="text-lg font-bold uppercase">{`#${invoiceId}`}</p>
        </div>
        <div className="flex flex-row">
          <p className="w-1/4">Date:</p>
          <p>{invoiceDate}</p>
        </div>
        <div className="flex flex-row">
          <p className="w-1/4">Due Date:</p>
          <p>{invoiceDueDate}</p>
        </div>

        <div className="flex flex-row">
          <p className="w-1/4">Client ID:</p>
          <p>{customerId}</p>
        </div>
      </div>
    </div>
  )
}

export default Header
